import React from 'react';
import {Spin} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';

export default function Spinner({fontSize}) {
  const antIcon = <LoadingOutlined style={{fontSize}} spin />;

  return <Spin indicator={antIcon} />;
}
